import { ArrowRight, ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";

export default function AgencyHero() {
  const scrollToForm = () => {
    const el = document.getElementById("kontakt");
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <section
      id="top"
      data-testid="agency-hero"
      className="relative pt-32 lg:pt-40 pb-20 lg:pb-32 overflow-hidden"
    >
      {/* atmospheric warm glow */}
      <div
        aria-hidden="true"
        className="pointer-events-none absolute inset-0"
        style={{
          background:
            "radial-gradient(ellipse 60% 50% at 78% 18%, rgba(251, 191, 36, 0.18), rgba(251, 191, 36, 0) 70%), radial-gradient(ellipse 55% 40% at 12% 80%, rgba(251, 191, 36, 0.10), rgba(251, 191, 36, 0) 75%)",
          filter: "blur(8px)",
        }}
      />
      {/* subtle grid */}
      <div
        aria-hidden="true"
        className="pointer-events-none absolute inset-0 opacity-[0.35]"
        style={{
          backgroundImage:
            "radial-gradient(circle at 1px 1px, rgba(255,255,255,0.06) 1px, transparent 0)",
          backgroundSize: "28px 28px",
        }}
      />

      <div className="relative max-w-7xl mx-auto px-5 sm:px-8 lg:px-10">
        <div className="max-w-4xl">
          <div className="inline-flex items-center gap-2 rounded-full bg-white/5 ring-1 ring-white/10 backdrop-blur px-3 py-1.5 text-[11px] font-bold uppercase tracking-[0.18em] text-brand-yellow">
            <span className="h-1.5 w-1.5 rounded-full bg-brand-yellow animate-pulse" />
            Agencja marketingowa dla branży PV
          </div>

          <h1
            className="mt-6 font-heading font-extrabold tracking-tight text-white text-4xl sm:text-5xl lg:text-7xl leading-[1.02]"
            data-testid="agency-hero-h1"
          >
            Nowoczesny system{" "}
            <span className="relative inline-block">
              <span className="relative z-10 text-brand-yellow">pozyskiwania klientów</span>
            </span>{" "}
            dla firm fotowoltaicznych.
          </h1>

          <p className="mt-7 text-lg sm:text-xl text-white/65 max-w-2xl leading-relaxed">
            Strony, które konwertują. Formularze, które trafiają. Telefony,
            które dzwonią. Bez chaosu, bez „kreatywnego" balastu.
          </p>

          <div className="mt-10 flex flex-col sm:flex-row gap-3 sm:gap-4">
            <Link
              to="/przyklad-strony"
              data-testid="agency-hero-demo-btn"
              className="inline-flex items-center justify-center h-14 px-7 rounded-full bg-white text-[#0B0F1A] font-semibold text-base shadow-lg hover:shadow-xl hover:bg-white/95 hover:scale-[1.02] active:scale-95 transition-all"
            >
              Zobacz przykład
              <ArrowUpRight className="ml-2 h-5 w-5" />
            </Link>
            <button
              onClick={scrollToForm}
              data-testid="agency-hero-contact-btn"
              className="inline-flex items-center justify-center h-14 px-7 rounded-full bg-brand-yellow hover:bg-brand-yellowHover text-brand-yellowFg font-semibold text-base shadow-lg hover:shadow-xl hover:scale-[1.02] active:scale-95 transition-all"
            >
              Umów rozmowę
              <ArrowRight className="ml-2 h-5 w-5" />
            </button>
          </div>

          <div className="mt-14 grid grid-cols-1 sm:grid-cols-3 gap-6 sm:gap-8 max-w-3xl">
            <Stat value="2 sek." label="lead na Telegram po wysłaniu formularza" />
            <Stat value="7 dni" label="i Twoja strona jest gotowa" />
            <Stat value="Branża PV" label="znamy ją od środka, nie z prezentacji" />
          </div>
        </div>
      </div>
    </section>
  );
}

function Stat({ value, label }) {
  return (
    <div>
      <div className="font-heading font-extrabold text-3xl sm:text-4xl text-white tracking-tight">
        {value}
      </div>
      <div className="mt-1 text-xs sm:text-sm text-white/55 leading-snug">{label}</div>
    </div>
  );
}
